import {useIntl} from 'react-intl'

export default function useGiftCardFields({
    form: {
        control,
        formState: {errors},
        watch
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const recipientEmail = watch(`${prefix}recipientEmail`)

    const fields = {
        yourName: {
            name: `${prefix}yourName`,
            label: formatMessage({
                id: 'gift_card_form.your_name.label',
                defaultMessage: 'Your name*'
            }),
            type: 'text',
            variant: 'floating',
            rules: {
                required: formatMessage({
                    id: 'gift_card_form.your_name.required',
                    defaultMessage: 'Enter your name'
                })
            },
            error: errors[`${prefix}yourName`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        recipientName: {
            name: `${prefix}recipientName`,
            label: formatMessage({
                id: 'gift_card_form.recipient_name.label',
                defaultMessage: "Recipient's name*"
            }),
            type: 'text',
            variant: 'floating',
            rules: {
                required: formatMessage({
                    id: 'gift_card_form.recipient_name.required',
                    defaultMessage: "Enter the recipient's name"
                })
            },
            error: errors[`${prefix}recipientName`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        recipientEmail: {
            name: `${prefix}recipientEmail`,
            label: formatMessage({
                id: 'gift_card_form.recipient_email.label',
                defaultMessage: "Recipient's email*"
            }),
            type: 'email',
            variant: 'floating',
            rules: {
                required: formatMessage({
                    id: 'use_giftcard_fields.error.pattern_email',
                    defaultMessage: 'Use a valid email format, like  name@example.com'
                }),
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: formatMessage({
                        defaultMessage: 'Use a valid email format, like  name@example.com',
                        id: 'use_giftcard_fields.error.pattern_email'
                    })
                }
            },
            error: errors[`${prefix}recipientEmail`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        confirmRecipientEmail: {
            name: `${prefix}confirmRecipientEmail`,
            label: formatMessage({
                id: 'gift_card_form.confirm_recipient_email.label',
                defaultMessage: "Confirm recipient's email*"
            }),
            type: 'email',
            variant: 'floating',
            rules: {
                required: formatMessage({
                    id: 'gift_card_form.confirm_recipient_email.mismatch',
                    defaultMessage: 'Emails do not match'
                }),
                validate: (value) => {
                    if (value !== recipientEmail) {
                        return formatMessage({
                            id: 'gift_card_form.confirm_recipient_email.mismatch',
                            defaultMessage: 'Emails do not match'
                        })
                    }
                    return true
                }
            },
            error: errors[`${prefix}confirmRecipientEmail`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        message: {
            name: `${prefix}message`,
            label: formatMessage({
                id: 'gift_card_form.message.label',
                defaultMessage: 'Message (optional)'
            }),
            type: 'textarea',
            variant: 'floating',
            rules: {},
            error: errors[`${prefix}message`],
            control,
            rows: 4,
            maxLength: 250,
            showCharacterCount: true
        }
    }

    return fields
}